import { combineReducers } from 'redux'
import misc from './misc'
import sortParams from './sort_params'

export default combineReducers({
  misc,
  sortParams,
})
